<template>
  <PlanBanner :show-navigation="false" />

  <main class="my-10">
    <AppContentLoader
      v-if="loading"
      text="Loading Plan..."
    />

    <span
      v-else-if="!plan"
      class="text-center mt-5 block"
    >
      Failed to load plan
    </span>

    <div
      v-else
      class="flex items-start container-padding"
    >
      <PlanOverviewCoverPage :plan="plan" />

      <!-- Show warning and hid action when the district is archived -->
      <div
        v-if="currentDistrict.archived"
        class="ml-10 border border-danger bg-danger/10 text-danger w-[400px]"
      >
        <p class="p-5 pb-0 text-sm font-semibold mb-1">
          This district has been archived
        </p>

        <div class="text-xs [&_*]:px-5 [&_*]:leading-[17px]">
          <p class="pb-5 mb-0">
            You cannot make changes to this document as the district has been archived.
            If you would like to make changes the district would have to be restored.
          </p>
        </div>
      </div>

      <div
        v-else
        class="bg-white w-[550px] border border-[#E2E1E3] ml-5 [&_p]:text-black"
      >
        <PlanOverviewActions
          :plan="plan"
          @download-pdf="downloadPdf"
        />

        <PlanOverviewWorkflow
          v-if="canViewWorkflow"
          :plan="plan"
        />
      </div>
    </div>
  </main>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { PlanBanner } from '@/components/banners';
import { useHttp } from '@/composables/index.js';
import { Role } from '@/const.js';
import { useAuthStore } from '@/store/index.js';
import { PlanOverviewWorkflow, PlanOverviewCoverPage, PlanOverviewActions } from '@/components/plan';
import { usePdfStore } from '@/store/planPdf.js';

const route = useRoute();
const router = useRouter();

const user = useAuthStore().user;
const pdfStore = usePdfStore();

const plan = ref();
const loading = ref(true);

const currentDistrict = computed(() => user?.districts?.find(d => d.current));
const canViewWorkflow = computed(() => user?.roles.some(r => [Role.Admin, Role.Capturer, Role.Reviewer, Role.Viewer].includes(r)));

const loadPlan = async () => {
  const response = await useHttp().get(`/districts/${route.params.district}/plans/${route.params.plan}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    plan.value = response.data;
    plan.value.workflowStep = 0;
  }

  console.log(plan.value);
  loading.value = false;
};

loadPlan();

// const publishPlan = async () => {
//   publishing.value = true;
//
//   const response = await useHttp().post(`/districts/${route.params.district}/plans/${route.params.plan}/publish`);
//
//   if (response.statusCode === HttpStatusCode.Ok) {
//     plan.value = response.data;
//
//     toasts.success('Plan published');
//   }
//
//   publishing.value = false;
//   showModal.value.publish = false;
//   showModal.value.republish = false;
// };
//
// const unpublishPlan = async () => {
//   unpublishing.value = true;
//
//   const response = await useHttp().post(`/districts/${route.params.district}/plans/${route.params.plan}/unpublish`);
//
//   if (response.statusCode === HttpStatusCode.Ok) {
//     plan.value = response.data;
//
//     toasts.success('Plan unpublished');
//   }
//
//   unpublishing.value = false;
//   showModal.value.unpublish = false;
// };

const downloadPdf = () => {
  const pdfPreviewRoute = router.resolve({ name: 'app_plan_pdf_preview' }).href;

  pdfStore.startGeneration(
    route.params.plan,
    pdfPreviewRoute,
  );
};
</script>

